import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Modal } from 'semantic-ui-react';
import StyledButton from '../../common/StyledButton';
import { hideModal, createLoadingSelector } from 'erisxkit/client';
import {
  fetchAuthorizedIPs,
  fetchIpAuthorizationHistory,
  REMOVE_AUTHORIZED_IP,
  removeAuthorizedIPPromiseCreator,
} from '../../reducers/authorizedIPsReducer';
import {
  FUNDING_PASSWORD,
  REMOVE_IP_ADDRESS_MODAL,
} from '../../constants/modalTypes';
import { getUserMemberIds } from '../../reducers/userReducer';

const Buttons = styled(Modal.Actions)`
  display: flex;
  justify-content: space-between;
`;
const Cancel = styled(StyledButton)`
  width: 150px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
`;

const Remove = styled(StyledButton)`
  width: 150px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
`;

const Title = styled.p`
  font-weight: bold;
  text-align: center;
  font-size: 18px;
  && {
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

const SubTitle = styled.p`
  font-weight: 500;
  text-align: center;
  font-size: 16px;
  && {
    margin-bottom: 20px;
  }
`;

const RemoveAuthorizedIPModal = ({ ipAddress }) => {
  const dispatch = useDispatch();
  const memberIds = useSelector(getUserMemberIds);

  const hideModals = useCallback(() => {
    dispatch(hideModal(REMOVE_IP_ADDRESS_MODAL));
    dispatch(hideModal(FUNDING_PASSWORD));
  }, [dispatch]);

  const loading = useSelector((state) =>
    createLoadingSelector([REMOVE_AUTHORIZED_IP])(state),
  );

  const onRemoveIPAddress = useCallback(() => {
    const payload = {
      ipAddress,
    };
    removeAuthorizedIPPromiseCreator(payload, dispatch)
      .then(() => {
        // Refetch IP Authorization History and Authorized IPs List
        dispatch(fetchAuthorizedIPs({ memberIds }));
        dispatch(fetchIpAuthorizationHistory({ memberIds }));
        hideModals();
      })
      .catch(() => hideModal());
  }, [dispatch, hideModals, ipAddress, memberIds]);

  return (
    <>
      <Modal.Content scrolling>
        <Title>Please confirm the following action</Title>
        <SubTitle>
          <b>{ipAddress}</b> {` will be removed from authorized IPs`}
        </SubTitle>
      </Modal.Content>
      <Buttons>
        <Cancel onClick={() => dispatch(hideModal())} text="Cancel" />
        <Remove
          danger
          onClick={onRemoveIPAddress}
          disabled={loading}
          text="Remove"
        />
      </Buttons>
    </>
  );
};

RemoveAuthorizedIPModal.defaultProps = {
  ipAddress: '',
};

RemoveAuthorizedIPModal.propTypes = {
  ipAddress: PropTypes.string,
};

export default RemoveAuthorizedIPModal;
